var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shift-manage.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-dc76b0be!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shift-manage.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftManage.vue
// module id = 723
// module chunks = 1